import * as Actions from '../../../Modules/CmsActions'
import type { IFileData, IPagination } from '../../../Types'

interface State {
  pagination: IPagination
  loading: boolean
  saving: boolean
  edit: null | IFileData
  list: IFileData[]
}

const initialState: State = {
  loading: false,
  saving: false,
  edit: null,
  list: [],
  pagination: {
    current_page: 1,
    first_page_url: null,
    from: 0,
    last_page: 1,
    last_page_url: null,
    next_page_url: null,
    path: null,
    per_page: 15,
    prev_page_url: null,
    to: 0,
    total: 0,
  },
}

const UIFileReducer = (state: State = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_FETCH_ALL_FILE:
    case Actions.REQUEST_FETCH_FILE:
      return loading(state)

    case Actions.REQUEST_CREATE_FILE:
    case Actions.REQUEST_UPDATE_FILE:
    case Actions.REQUEST_DELETE_FILE:
    case Actions.REQUEST_DOWNLOAD_FILE:
    case Actions.REQUEST_PREVIEW_FILE:
      return saving(state)

    case Actions.FINISH_FETCH_ALL_FILE:
      return updateList(state, action.payload)

    case Actions.FINISH_FETCH_FILE:
      return updateEditInfoWithLoaded(state, action.payload.file)

    case Actions.FINISH_CREATE_FILE:
    case Actions.FINISH_UPDATE_FILE:
    case Actions.FINISH_DELETE_FILE:
    case Actions.FINISH_DOWNLOAD_FILE:
    case Actions.FINISH_PREVIEW_FILE:
      return saved(state)

    case Actions.UNLOAD_FILE:
      return { ...state, edit: null }

    case Actions.ERROR_FILE:
      return loaded(saved(state))

    default:
      return state
  }
}

function loading(state) {
  return { ...state, loading: true }
}

function loaded(state) {
  return { ...state, loading: false }
}

function saving(state) {
  return { ...state, saving: true }
}

function saved(state) {
  return { ...state, saving: false }
}

function updateList(state, payload) {
  const { files, pagination } = payload
  const updated = { ...state, list: files, pagination }
  return loaded(updated)
}

function updateEditInfoWithLoaded(state, file) {
  const updated = { ...state, edit: file }
  return loaded(updated)
}

export default UIFileReducer
